/**
 * @param {{profile:any,birthDay:any}} data
 */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Form } from "react-bootstrap";
import WofButton from "../WofButton";
import { RootState } from "../../reducers";

import { postApiGiveawaySignupJWT } from "../../api/cms/api";
import generateJWT from "./GiveawaySignUpJWT";
import generateRequestData from "./GiveawayRequestData";

import "./styles.scss";
import { Redirect, Route } from "react-router-dom";
import { Props } from "./types";
import {
  InEligbleAlert,
  SimpleField,
  EmailField,
  DobField,
  PhoneField,
  GenderField,
  StateField,
} from "./Fields";
let res: any = "";
let exclude_States: any = [];
const canada_pattern = /[a-zA-Z][0-9][a-zA-Z](-| |)[0-9][a-zA-Z][0-9]/;

const GiveawayEntryForm: React.FC<Props> = ({
  title,
  titleFontColor,
  giveawayId,
  description,
  descriptionFontColor,
  submitLabel,
  profile,
  uid,
  excludeCanada,
  excludeCanadaMessage,
  minimumAge,
  underageMessage,
  bonusRoundSolution,
  bonusRoundSolutionVisible,
  secondBonusRoundSolutionVisible,
  secondBonusRoundSolution,
  firstName,
  lastName,
  email,
  phone,
  birthDate,
  zipCode,
  gender,
  specialOffers,
  giveawayOptIn,
  dyanmodb_table,
  dayLimitMessage,
  weekLimitMessage,
  stateProvince,
  includedStates,
  excludedStates,
  excludeStatesErrorMessage,
  giveaways
}) => {
 const [sendingRequest, setSendingRequest] = useState(false);
  const [validated, setValidated] = useState(false);
  const [bonusRoundSolutionValue, setBonusRoundSolution] = useState("");
  const [secondBonusRoundSolutionValue, setSecondBonusRoundSolution] = useState("");
  const [firstNameValue, setFirstNameValue] = useState(
    profile ? profile.firstName : ""
  );
  const [lastNameValue, setLastNameValue] = useState(
    profile ? profile.lastName : ""
  );
  const [emailValue, setEmailValue] = useState("");
  const [phoneValue, setPhoneValue] = useState("");
  const [birthDateValue, setBirthDateValue] = useState("");
  const [zipCodeValue, setZipCodeValue] = useState(profile ? profile.zip : "");
  const [genderValue, setGenderValue] = useState("");
  const [smsValue, setSmsValue] = useState(false);
  const [specialOffersValue, setSpecialOffersValue] = useState(false);
  const [giveawayOptInValue, setGiveawayOptInValue] = useState(false);
  const [isUnderaged, setIsUnderaged] = useState(false);
  const [isCountryEligible, setCountryEligible] = useState(true);
 const [doRedirect, setDoRedirect] = useState(false);
  const [Zipcanada, setZipCanada] = useState(false);
  //const [giveaways, setGiveawaysOptIn] = useState('');
  const [state, setStateData] = useState(
    profile && profile.state ? profile.state : ""
  );
  const [excludeStateMessage, showExcludeStateMessage] = useState(false);
  useEffect(() => {
    if (profile && underageMessage) {
      // setIsUnderaged(+profile.age < minimumAge);
    }
  }, [
    profile,
    minimumAge,
    underageMessage,
    excludeCanada,
    excludeCanadaMessage,
    uid,
  ]);
  useEffect(() => {
    if (
      profile &&
      excludeCanada &&
      profile.zip &&
      canada_pattern.test(profile.zip)
    ) {
      setCountryEligible(false);
    }
  }, [profile, excludeCanada, excludeCanadaMessage, uid]);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    let isValidForm = form.checkValidity();
    setValidated(true);
    let email_value: string = (document.getElementById(
      "Email"
    ) as HTMLInputElement).value;
    let cemail_value: string = (document.getElementById(
      "Confirm Email"
    ) as HTMLInputElement).value;

    if (email_value !== cemail_value) {
      (document.getElementById(
        "Confirm Email"
      ) as HTMLInputElement).classList.remove("is-valid");
      (document.getElementById(
        "Confirm Email"
      ) as HTMLInputElement).classList.add("email-invalid");
      isValidForm = false;
    }
    if (isValidForm && email_value === cemail_value) {
      const canada_states = [
        "Alberta",
        "British Columbia",
        "Manitoba",
        "New Brunswick",
        "Newfoundland",
        "Northwest Territories",
        "Nova Scotia",
        "Nunavut",
        "Ontario",
        "Prince Edward Island",
        "Quebec",
        "Saskatchewan",
        "Yukon Territory"
      ];
      // if (isValidForm) {
      if (excludeCanada && (canada_pattern.test(zipCodeValue) || canada_states.includes(state))) {

        if (canada_pattern.test(zipCodeValue) && canada_states.includes(state)) {
          setZipCanada(true);
          (document.getElementById("validationCustomdropdown") as HTMLInputElement).classList.add(
            "email-invalid"
          );
          (document.getElementById("zip_code") as HTMLInputElement).classList.add(
            "email-invalid"
          );
        }
        else if (canada_states.includes(state)) {
          setZipCanada(true);
          (document.getElementById("validationCustomdropdown") as HTMLInputElement).classList.add(
            "email-invalid"
          );
        }
        else if (canada_pattern.test(zipCodeValue)) {
          setZipCanada(true);
          (document.getElementById("zip_code") as HTMLInputElement).classList.add(
            "email-invalid"
          );
        }
      } else {
        (document.getElementById(
          "zip_code"
        ) as HTMLInputElement).classList.remove("email-invalid");
        setZipCanada(false);
        (document.getElementById("validationCustomdropdown") as HTMLInputElement).classList.remove(
          "email-invalid"
        );

        if (excludedStates) {
          exclude_States = [];
          for (let key in excludedStates) {
            let value = excludedStates[key];
            exclude_States.push(value);
          }
        }
        if (state == "" && profile.state) {
          await setStateData(profile.state);
        }
        //console.log(state, exclude_States, exclude_States.includes(state));
        if (exclude_States && exclude_States.includes(state)) {
          showExcludeStateMessage(true);
          (document.getElementById("validationCustomdropdown") as HTMLInputElement).classList.add(
            "email-invalid"
          );
        } else {
          showExcludeStateMessage(false);
          (document.getElementById("validationCustomdropdown") as HTMLInputElement).classList.remove(
            "email-invalid"
          );
          const requestData = {
            wheelWatcherId: profile.spinID,
            giveawayId: giveawayId,
            uid: uid,
            // formFields: {
            bonusRoundSolution: bonusRoundSolutionValue,
            secondBonusRoundSolution: secondBonusRoundSolutionValue,
            firstName:
              firstNameValue !== ""
                ? firstNameValue
                : profile.firstName
                ? profile.firstName
                : "",
            lastName:
              lastNameValue !== ""
                ? lastNameValue
                : profile.lastName
                ? profile.lastName
                : "",
            email: emailValue,
            phone: phoneValue,
            birthDate: birthDateValue,
            zipCode:
              zipCodeValue !== ""
                ? zipCodeValue
                : profile.zip
                ? profile.zip
                : "",
            gender: genderValue,
            specialOffers: specialOffersValue,
            giveawayOptIn: giveawayOptInValue,
            state: state,
            // },
          };
          const requestData2 = {
            wheelWatcherId: profile.spinID,
            giveawayId: dyanmodb_table,
            // giveawayId: "wof-giveaways-table-"+dyanmodb_table,
            formFields: {
              giveawayId: dyanmodb_table,
              bonusRoundSolution: bonusRoundSolutionValue,
              secondBonusRoundSolution: secondBonusRoundSolutionValue,
              firstName:
                firstNameValue !== ""
                  ? firstNameValue
                  : profile.firstName
                  ? profile.firstName
                  : "",
              lastName:
                lastNameValue !== ""
                  ? lastNameValue
                  : profile.lastName
                  ? profile.lastName
                  : "",
              email: emailValue,
              phone: phoneValue,
              birthDate: birthDateValue,
              zipCode:
                zipCodeValue !== ""
                  ? zipCodeValue
                  : profile.zip
                  ? profile.zip
                  : "",
              gender: genderValue,
              specialOffers: specialOffersValue,
              giveawayOptIn: giveawayOptInValue,
              state: state !== "" ? state : profile.state ? profile.state : "",
            },
          };
          const requestData3 = {
            giveawayId: giveawayId,
            email: emailValue,
          };

          // Prepare for multiple giveaways.
          let allGiveawaysIds: any = [];

          // Adds giveawayid and giveawayOptIn for main giveaway to array.
          allGiveawaysIds.push({
            giveawayId: dyanmodb_table,
            giveawayOptIn: giveawayOptInValue,
          });

          // Get all checkboxes checked from extra Giveaways. giveawayOptInExtraCheckbox.
          let checkedBoxes = document.querySelectorAll<HTMLInputElement>('.giveawayOptInExtraCheckbox input');

          for (let i = 0; i < checkedBoxes.length; i++) {
            let myExtraDynamoTable = checkedBoxes[i].id;
            // Validates if checked.
            let inputChecked = false;
            if (checkedBoxes[i].checked) {
              inputChecked = true;
            }

            // Adds array with values for api calls.
            allGiveawaysIds.push({
              giveawayId: myExtraDynamoTable,
              giveawayOptIn: inputChecked,
            });
          }

          // Make request for all giveaways [generateRequestData].
          // Const allRequestResponses gets result from all calls.
          const allRequestResponses = await generateRequestData(requestData2, allGiveawaysIds);
           allRequestResponses.forEach((rqt: any) => {
             // Validates if "any" of the request is successful.
             if (rqt.doRedirect === true) {
               // Set doRedirect true to preserve logic.
               setDoRedirect(true);
             }
           });
        }
      }
    }
  };
  let pathname = window.location.pathname;

  return (
    profile &&
    (isUnderaged ? (
      underageMessage ? (
        <InEligbleAlert message={underageMessage} />
      ) : null
    ) : !isCountryEligible ? (
      excludeCanadaMessage ? (
        <InEligbleAlert message={excludeCanadaMessage} />
      ) : null
    ) : (
      <div className="giveaway_entry_form">
        {doRedirect && (
          <Route
            to={
              window.location.pathname +
              (pathname[pathname.length - 1] === "/"
                ? "confirmation"
                : "/confirmation")
            }
            component={() => {
              window.location.href =
                window.location.pathname +
                (pathname[pathname.length - 1] === "/"
                  ? "confirmation"
                  : "/confirmation");
              return null;
            }}
          />
        )}
        <h1 className="ga-title" style={{color: titleFontColor}}>{title}</h1>

        <div
          className="ga-description"
          style={{color: descriptionFontColor}}
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
        <Form
          noValidate
          validated={validated}
          onSubmit={handleSubmit}
          className={`ga-form${sendingRequest ? " sending-request" : ""}`}
        >
          <div className="ga-form-inputs">
            <div className="row full-width">
              <div className="col-12">
                <div style={{ color: "#000", paddingBottom: "20px" }}>
                  { secondBonusRoundSolutionVisible ?
                    "Each correct puzzle solution will earn you one entry into this Promotion." :
                    ""
                  }
                </div>
              </div>
              <div className="col-12 col-lg-6">
                {bonusRoundSolutionVisible && bonusRoundSolution && (
                  <SimpleField
                    onChange={setBonusRoundSolution}
                    {...bonusRoundSolution}
                    fieldType="bonusRoundSolution"
                    initialValue={""}
                  />
                )}
              </div>
              <div className="col-12 col-lg-6">
                {secondBonusRoundSolutionVisible && secondBonusRoundSolution && (
                  <SimpleField
                    onChange={setSecondBonusRoundSolution}
                    {...secondBonusRoundSolution}
                    fieldType="secondBonusRoundSolution"
                    initialValue={""}
                  />
                )}
              </div>
            </div>
            <div className="clearfix"></div>
            <div className="full-width" style={{
              color: "#000",
              paddingBottom: "20px",
              paddingTop: "40px"
            }}>
              All Fields Required
            </div>
            <div className="col-lg-6 p-0">
              {firstName && (
                <SimpleField
                  {...firstName}
                  fieldType="firstName"
                  initialValue={profile.firstName}
                  onChange={setFirstNameValue}
                />
              )}
              {lastName && (
                <SimpleField
                  {...lastName}
                  fieldType="lastName"
                  initialValue={profile.lastName}
                  onChange={setLastNameValue}
                />
              )}
              {email && (
                <EmailField
                  {...email}
                  fieldType="email"
                  initialValue={profile.email}
                  onChange={setEmailValue}
                />
              )}

              {birthDate && (
                <DobField
                  {...birthDate}
                  fieldType="birthDate"
                  initialDay={profile.birthDay}
                  initialMonth={profile.birthMonth}
                  initialYear={profile.birthYear}
                  onChange={setBirthDateValue}
                />
              )}
            </div>
            <div className="col-lg-6 p-0">
              {phone && (
                <PhoneField
                  {...phone}
                  smsChecked={smsValue}
                  fieldType="phone"
                  initialValue={profile.number}
                  onChange={setPhoneValue}
                  onSelectChange={setSmsValue}
                />
              )}
              {includedStates && (
                <StateField
                  {...stateProvince}
                  fieldType="dropdown"
                  initialValue={profile.state ? profile.state : ''}
                  onChange={async (e) => {
                    if (exclude_States.includes(e)) {
                      showExcludeStateMessage(true);
                      (document.getElementById("validationCustomdropdown") as HTMLInputElement).classList.add(
                        "email-invalid"
                      );
                    } else {
                      showExcludeStateMessage(false);
                      (document.getElementById("validationCustomdropdown") as HTMLInputElement).classList.remove(
                        "email-invalid"
                      );
                    }
                    await setStateData(e);
                  }}
                  label={stateProvince && stateProvince.label ? stateProvince.label : 'State/Province'}
                  placeholder={"state"}
                  errorMessage={"Please select State"}
                  includedStates={includedStates}
                  id="stateProvince"
                />
              )}
              {zipCode && (
                <SimpleField
                  {...zipCode}
                  fieldType="zipCode"
                  initialValue={profile.zip}
                  onChange={setZipCodeValue}
                  pattern="((\d{5}-\d{4})|(\d{5})|([AaBbCcEeGgHhJjKkLlMmNnPpRrSsTtVvXxYy]\d[A-Za-z]\s?\d[A-Za-z]\d))"
                />
              )}
              {gender && (
                <GenderField
                  {...gender}
                  fieldType="gender"
                  initialValue={profile.gender}
                  onChange={setGenderValue}
                />
              )}
            </div>
            <div className="col-lg-12 p-0 mt-3 checkSO">
              {specialOffers && (
                <Form.Group>
                  <Form.Check
                    aria-label={specialOffers}
                    defaultChecked={specialOffersValue}
                    onClick={(e: any) =>
                      setSpecialOffersValue(e.target.checked)
                    }
                  />
                  <span
                    className="ga-specialOffer"
                    dangerouslySetInnerHTML={{
                      __html: specialOffers,
                    }}
                  />
                </Form.Group>
              )}
            </div>
            <div className="col-lg-12 p-0 mt-3 checkSO">
              {giveawayOptIn && (
                <Form.Group>
                  <Form.Check
                    aria-label={giveawayOptIn}
                    defaultChecked={giveawayOptInValue}
                    onClick={(e: any) =>
                      setGiveawayOptInValue(e.target.checked)
                    }
                  />
                  <span
                    className="checkbox-type-field ga-giveawayOptIn"
                    dangerouslySetInnerHTML={{
                      __html: giveawayOptIn,
                    }}
                  />
                </Form.Group>
              )}
            </div>

            {/* Multiple giveaways. Expose multiple Partner opt-ins  */}
            {giveaways ?
              (<div className={"col-lg-12 p-0 mt-3 checkSO ga-giveawayOptInMultiple cta-multiple"}> {
                giveaways.map((items: any) => (

                  items.components.map((item: any, i: number) => {

                    // Date validation.
                    let todayDate = new Date();
                    let d_start = new Date(items.start_date);
                    let d_end = new Date(items.end_date);
                    let showExtraGiveaway = false;

                    if (d_start.getTime() <= todayDate.getTime() && d_end.getTime() >= todayDate.getDate()) {
                      showExtraGiveaway = true;
                    }

                    // Validates date, dyanmodb_table and value for text for checkbox.
                    if (item.componentName == "giveawayEntryForm" &&
                      showExtraGiveaway &&
                      items.page.dyanmodb_table &&
                      item.data.giveawayOptIn ) {

                      return(
                      <Form.Group>
                        <Form.Check
                          aria-label={item.data.giveawayOptIn}
                          value={items.page.dyanmodb_table}
                          id = {items.page.dyanmodb_table}
                          className = "giveawayOptInExtraCheckbox"
                        />
                        <span
                          className="checkbox-type-field ga-giveawayOptIn ga-giveawayOptInExtra"
                          dangerouslySetInnerHTML={{
                            __html: item.data.giveawayOptIn,
                          }}
                        />
                      </Form.Group>)
                    }

                  })
                ))}
              </div> )
              : null}
          </div>
          <span
            id={res.message}
            dangerouslySetInnerHTML={{
              __html: dayLimitMessage,
            }}
            style={{ display: "none" }}
          />
          {excludeCanadaMessage && Zipcanada ? (
            <span
              id={"excludecanadamsg"}
              dangerouslySetInnerHTML={{
                __html: excludeCanadaMessage,
              }}
              style={{ display: "block" }}
            />
          ) : null}

          {excludeStatesErrorMessage && excludeStateMessage ? (
            <span
              id={"excludecanadamsg"}
              dangerouslySetInnerHTML={{
                __html: excludeStatesErrorMessage.replace("{state}", state),
              }}
              style={{ display: "block" }}
            />
          ) : null}

          <div className="ga-form-submit">
            <WofButton
              disabled={sendingRequest}
              id="giveaway_submit_button"
              type="submit"
            >
              {submitLabel}
            </WofButton>
          </div>
        </Form>
      </div>
    ))
  );
};

const mapStateToProps = (state: RootState) => ({
  profile: state.auth.profile,
  uid: state.auth.uid,
});

export default connect(mapStateToProps)(GiveawayEntryForm);
